import { StringData } from "../../core/StringData";

export class StringScrollbarVertical {
  private scrollbar: any;
  private thumb: any;
  private isDragging = false;
  private startCoordinate: number = 0;
  private startScrollPosition: number = 0;
  data: StringData;

  constructor(data: StringData, scrollbar: any, thumb: any) {
    this.data = data;
    this.scrollbar = scrollbar;
    this.thumb = thumb;
  }

  onResize(): void {
    const contentSize = this.data.viewport.contentHeight;
    const visibleSize = this.data.viewport.windowHeight;
    const thumbSize = (visibleSize / contentSize) * visibleSize;
    this.thumb.style.setProperty('--height', thumbSize + 'px');
    if (contentSize <= visibleSize) {
      this.scrollbar.classList.add('-hide');
    } else {
      this.scrollbar.classList.remove('-hide');
    }
  }

  updateThumb() {
    const contentHeight = this.data.viewport.contentHeight;
    const visibleHeight = this.data.viewport.windowHeight;
    
    this.thumb.style.setProperty('--position', `${(this.data.scroll.current / contentHeight) * visibleHeight + 'px'}`);
  }

  mouseDownEvent(e: MouseEvent) {
    this.startCoordinate = e.clientY;
    this.startScrollPosition = this.data.scroll.current;
  }

  mouseMoveEvent(e: MouseEvent) {
    const deltaY = e.clientY - this.startCoordinate;
    const newScrollPosition = this.startScrollPosition + (deltaY / this.data.viewport.windowHeight) * this.data.viewport.contentHeight;
    const maxScroll = this.data.scroll.bottomPosition;
    const clamped = Math.max(0, Math.min(newScrollPosition, maxScroll));
    this.data.scroll.current = clamped;
    this.data.scroll.target = clamped;
    window.scrollTo(0, clamped);
    this.updateThumb();
  }
}
